import React, { useEffect, useState } from 'react';
import {
  Box, Button, Dialog, DialogContent, DialogTitle, LinearProgress, Typography,
} from '@mui/material';

const DemoPreviewDialog = ({ open, onClose, url, title }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    if (open) setIframeLoaded(false);
  }, [open, url]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { height: '85vh' } }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h6" component="span">Preview: </Typography>
          <Typography variant="h6" component="span" color="text.secondary">{title}</Typography>
        </Box>
        <Button onClick={onClose} size="small">Close</Button>
      </DialogTitle>
      {open && url && !iframeLoaded && <LinearProgress />}
      <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
        {open && url && (
          <Box
            component="iframe"
            src={url}
            title={title}
            onLoad={() => setIframeLoaded(true)}
            sx={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
            allow="fullscreen"
            allowFullScreen
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DemoPreviewDialog;
